module.exports = __webpack_public_path__ + "static/media/shop_getty_tablet.c74d3d93.jpg";